type Listener = (isLoading: boolean) => void;

let isLoading = false;
const listeners = new Set<Listener>();

/**
 * Lets StaticPageLoading (mounted only while a static page's own JS chunk is
 * still being fetched on a client-side nav) tell RouteProgress "don't finish
 * yet" — so the top progress bar and the page content reveal together in one
 * moment instead of the bar completing early and leaving a second, separate
 * wait behind it.
 */
export const setStaticContentLoading = (next: boolean) => {
  isLoading = next;
  listeners.forEach((listener) => listener(isLoading));
};

export const subscribeStaticContentLoading = (listener: Listener) => {
  listeners.add(listener);
  listener(isLoading);

  return () => {
    listeners.delete(listener);
  };
};
